import React from 'react'
import {useState, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { startWindow, showWindow, hideWindow, focusWindow, fullScreen, closeWindow, hideStartMenu } from '../slices/mwSelectSlice';
// import calcLogo from '../img/about_moi64.jpg'
// import feedLogo from '../img/about_moi64.jpg'
// import dogLogo from '../img/about_moi64.jpg'
// import mediaLogo from '../img/about_moi64.jpg'

const StartMenuButton = ({windowID, logo}) => {
    const [hoverState, setHover] = useState(false) 
    const [imgURL, setImgURL] = useState('')
    const windowCheck = useSelector((state) => state.shower.window);
    const dispatch = useDispatch()
    
    const setHoverTrue = () => {
        setHover(true)
    }
      
    const setHoverFalse = () => {
        setHover(false)
    }
    const startMenuButtonPressed = () =>{
        if(windowCheck.find((w) => w.windowID === windowID).display == 'none'){
            dispatch(startWindow(windowID))
        }
        dispatch(focusWindow(windowID))
        dispatch(hideStartMenu())
    }


  return (
    <div id={windowID+'-button'} style={{
        width: '98%',
        height: '15%',
        position: 'relative',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '17%',
        backgroundPositionX: '10%',
        backgroundPositionY: '50%',
        backgroundImage: `url(${logo})`, 
        border: 'none',
        //outline: 'none',
        //outlineOffset: '-1px',
        //padding: '5px',
        //justifyContent: 'center',
        //alignContent: 'center',
        alignSelf: 'center',
        marginTop: '2%',
        marginBottom: '2%',
        marginRight: '1px',
        overflow: 'clip'
    }}>
        <button onMouseEnter={setHoverTrue} onMouseLeave={setHoverFalse} onClick={() => startMenuButtonPressed()}  style={{
            backgroundColor: hoverState ? 'rgba(255, 255, 255, 0.4)' : 'transparent',
            //position: 'relative',
            width: '100%',
            height: '100%',
            outline: 'none',
            border: 'none',
            alignSelf: 'center',
            cursor: 'pointer',
        }}>
            <p
                style={{
                    fontFamily: '"Terminal ", monospace',
                    fontSmooth: 'never',  
                    fontSize: '2vh',
                    paddingLeft: '25%',
                    verticalAlign: 'center',
                    position: 'relative',
                    //alignItems: 'flex-end',
                    textAlign: 'center',
                    paddingRight: '5%',
                }}>
                    {windowCheck.find((w) => w.windowID === windowID).title}    
                </p>
        </button>
    </div>
  )
}

export default StartMenuButton